<template>
    <div>
        <CRow>
            <CCol>
                <CCard>
                    <CCardHeader>
                        <strong>Создание лекарства</strong>
                    </CCardHeader>

                    <CCardBody>
                        <DrugUpsertForm
                            @success="$router.push(`/pharmacies/${$route.params.id}/drugs`)"
                            @dismiss="$router.go(-1)"
                        />
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>

<script>
    import DrugUpsertForm from '@/components/pharmacies/DrugUpsertForm'

    export default {
        name: 'DrugCreate',

        components: {
            DrugUpsertForm,
        },
    }
</script>

<style>

</style>